import { mapState, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapState({
      tokenId: (state) => state.user.auth.tokenId,
      userRole: (state) => state.user.userRole,
      fiduciary: (state) => state.user.fiduciary || {},
    }),
    ...mapGetters({
      hasUserInfo: 'user/hasUserInfo',
      hasFiduciaryInfo: 'user/hasFiduciaryInfo',
      hasAccessToBrowseIn: 'user/hasAccessToBrowseIn',
    }),
  },
};
